var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalenderIcon = function SvgCalenderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A3BD",
    d: "M5 .667V2h4V.667h1.334V2H13c.368 0 .667.298.667.667v10.666A.667.667 0 0 1 13 14H1a.667.667 0 0 1-.667-.667V2.667C.333 2.298.632 2 1 2h2.667V.667zm7.334 6.666H1.667v5.334h10.667zm-8 1.334V10H3V8.667zm3.333 0V10H6.334V8.667zm3.333 0V10H9.667V8.667zM3.667 3.333h-2V6h10.667V3.333h-2v1.334H9V3.333H5v1.334H3.667z"
  })));
};
export default SvgCalenderIcon;